import React from 'react';
import styles from './typography.module.css';

type TitleProps = React.HTMLAttributes<HTMLHeadingElement> & {
  $mobileColor?: string;
  $desktopColor?: string;
};

export const UHLesMillsTitle = React.forwardRef<HTMLHeadingElement, TitleProps>(
  function UHLesMillsTitle(
    { className, style, $mobileColor, $desktopColor, ...rest },
    ref,
  ) {
    const mobileColor = $mobileColor ?? '#000';
    const desktopColor = $desktopColor ?? $mobileColor ?? '#000';
    return (
      <h2
        ref={ref}
        className={className ? `${styles.title} ${className}` : styles.title}
        style={
          {
            ['--lm-title-color-m' as string]: mobileColor,
            ['--lm-title-color-d' as string]: desktopColor,
            ...style,
          } as React.CSSProperties
        }
        {...rest}
      />
    );
  },
);

type SubtitleProps = React.HTMLAttributes<HTMLParagraphElement> & {
  $color?: string;
};

export const UHLesMillsSubtitle = React.forwardRef<
  HTMLParagraphElement,
  SubtitleProps
>(function UHLesMillsSubtitle({ className, style, $color, ...rest }, ref) {
  return (
    <p
      ref={ref}
      className={className ? `${styles.subtitle} ${className}` : styles.subtitle}
      style={
        {
          ['--lm-subtitle-color' as string]: $color ?? 'rgba(0, 0, 0, 0.6)',
          ...style,
        } as React.CSSProperties
      }
      {...rest}
    />
  );
});
